import { useState } from "react";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Starfield } from "@/components/site/Starfield";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Catalogue } from "@/components/site/Catalogue";
import { ResearchBox } from "@/components/site/ResearchBox";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  const [productRef, setProductRef] = useState("");

  const handleInquire = (ref) => setProductRef(ref);
  const clearRef = () => setProductRef("");

  return (
    <main className="relative bg-[#050505] min-h-screen" data-testid="landing-page">
      <div className="fixed inset-0 z-0 pointer-events-none">
        <Starfield />
      </div>
      <div className="relative z-10">
        <Navbar />
        <Hero />
        <TrustBar />
        <EditorialMarquee />
        <Catalogue onInquire={handleInquire} />
        <ResearchBox onInquire={handleInquire} />
        <About />
        <Contact productRef={productRef} clearRef={clearRef} />
        <Footer />
      </div>
    </main>
  );
}
